import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types/RootState";

import { AddOrderDropDownKey } from "../types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) =>
  state.addOrderModalState || initialState;

export const selectIsAddOrderModalOpen = createSelector(
  [selectDomain],
  (addOrderModalState) => addOrderModalState.isOpen
);

export const selectAddOrderForm = createSelector(
  [selectDomain],
  (addOrderModalState) => addOrderModalState.form
);

export const selectAddOrderModalContext = createSelector(
  [selectDomain],
  (addOrderModalState) => addOrderModalState.context
);

export const selectAddOrderDropDowns = createSelector(
  [selectDomain],
  (addOrderModalState) => addOrderModalState.dropDowns
);

export const selectCustomerNames = createSelector(
  [selectAddOrderDropDowns],
  (dropDowns) => dropDowns.customers.items
);

export const selectCustomersLoading = createSelector(
  [selectAddOrderDropDowns],
  (dropDowns) => dropDowns.customers.loading
);

export const selectManufacturerNames = createSelector(
  [selectAddOrderDropDowns],
  (dropDowns) => dropDowns.manufacturers.items
);

export const selectManufacturersLoading = createSelector(
  [selectAddOrderDropDowns],
  (dropDowns) => dropDowns.manufacturers.loading
);

export const selectModelNames = createSelector(
  [selectAddOrderDropDowns],
  (dropDowns) => dropDowns.models.items
);

export const selectModelsLoading = createSelector(
  [selectAddOrderDropDowns],
  (dropDowns) => dropDowns.models.loading
);

export const selectDropDownHasMore = (key: AddOrderDropDownKey) =>
  createSelector([selectAddOrderDropDowns], (dropDowns) => {
    const dropDown = dropDowns[key];
    return dropDown.meta.currentPage < dropDown.meta.totalPages;
  });
